import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {OrderCommentTagsActions} from '../store';
import {OrderCommentTagsSelectors} from '../store/selectors';

@Injectable()
export class OrderCommentTagsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadOrderCommentTagsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadOrderCommentTagsDone() {
    return this.store.pipe(
      select(OrderCommentTagsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(OrderCommentTagsActions.ReadOrderCommentTags());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
